import "./style.css"

function Access() {

    return (
        <div className="page_access">

        </div>
    )
}

export default Access;